
    import './styles.scoped.css';
    export default {
  "segment__path": "awsui_segment__path_1edmh_174l7_103",
  "segment": "awsui_segment_1edmh_174l7_103",
  "segment__hover": "awsui_segment__hover_1edmh_174l7_130",
  "label": "awsui_label_1edmh_174l7_144",
  "root": "awsui_root_1edmh_174l7_162",
  "content": "awsui_content_1edmh_174l7_166",
  "content--small": "awsui_content--small_1edmh_174l7_166",
  "content--fit-height": "awsui_content--fit-height_1edmh_174l7_169",
  "content--without-labels": "awsui_content--without-labels_1edmh_174l7_172",
  "content--medium": "awsui_content--medium_1edmh_174l7_178",
  "content--large": "awsui_content--large_1edmh_174l7_190",
  "status-container": "awsui_status-container_1edmh_174l7_207",
  "chart-container": "awsui_chart-container_1edmh_174l7_211",
  "chart-container--fit-height": "awsui_chart-container--fit-height_1edmh_174l7_215",
  "chart-container-chart-plot": "awsui_chart-container-chart-plot_1edmh_174l7_220",
  "chart-container-chart-plot--fit-height": "awsui_chart-container-chart-plot--fit-height_1edmh_174l7_223",
  "inner-content": "awsui_inner-content_1edmh_174l7_229",
  "segment__highlight": "awsui_segment__highlight_1edmh_174l7_240",
  "segment--dimmed": "awsui_segment--dimmed_1edmh_174l7_255",
  "segment--highlighted": "awsui_segment--highlighted_1edmh_174l7_258",
  "label--dimmed": "awsui_label--dimmed_1edmh_174l7_275",
  "label--align-right": "awsui_label--align-right_1edmh_174l7_278",
  "label-text": "awsui_label-text_1edmh_174l7_286",
  "label__description": "awsui_label__description_1edmh_174l7_294",
  "label-line": "awsui_label-line_1edmh_174l7_301",
  "label--highlighted": "awsui_label--highlighted_1edmh_174l7_305",
  "popover-header": "awsui_popover-header_1edmh_174l7_309"
};
  